/* APOCALISSE SOLD OUT - chat WhatsApp (sostituisce l'app RT Social Chat)
   - Computer: pulsante sempre fisso in basso a destra.
   - Telefono: il pulsante compare dopo un po' di scorrimento (o dopo qualche secondo), sparisce mentre scorri,
     quando c'e il menu, la tastiera o un bottone importante (aggiungi al carrello, paga) nello stesso punto,
     e sale sopra la barra fissa "Aggiungi al carrello" della scheda prodotto.
   - Il cliente sceglie il tipo di richiesta, e il messaggio arriva gia compilato su WhatsApp.
   - Italiano e inglese: la lingua e quella del sito (html lang). "Apocalisse Sold Out" non si traduce mai.
   - Taglie: se il cliente e su un capo, o sceglie T-SHIRT / FELPE / PANTALONI, compare la tabella taglie giusta
     (dati e testi in snippets/aso-size.liquid, disegno in assets/aso-size.js).
   Versione leggera: niente piu controllo continuo ogni 0,9 secondi; la posizione si ricontrolla solo quando qualcosa cambia
   (scorrimento finito, menu, carrello laterale, finestre, tastiera, barra del carrello). Il comportamento e lo stesso. */
(function () {
  'use strict';
  var W = window, D = document, H = D.documentElement;
  var root = D.getElementById('aso-wa');
  if (!root || root.__ready) return;
  root.__ready = true;

  var fab = root.querySelector('.aso-wa__fab');
  var panel = root.querySelector('.aso-wa__panel');
  var body = root.querySelector('.aso-wa__body');
  var scrim = root.querySelector('.aso-wa__scrim');
  var closeBtn = root.querySelector('.aso-wa__x');
  var ICON = root.querySelector('.aso-wa__fab svg').innerHTML;

  /* ---------- testi: italiano e inglese ---------- */
  var DICT = {
    it: {
      hello: 'Ciao! Di cosa hai bisogno?',
      cats: ['T-SHIRT', 'FELPE', 'PANTALONI'],
      topics: { info: 'Info su un capo', size: 'Che taglia scelgo?', swap: 'Cambio taglia', refund: 'Reso / recesso', other: 'Altro' },
      quick: 'Risposte veloci',
      ship_t: 'Spedizione',
      ship_a: 'Spediamo con corriere: la consegna avviene in 24/48 ore dopo l\'evasione dell\'ordine e ti arriva un\'email con il numero di tracking. La spedizione è gratis sopra i 150 €.',
      pay_t: 'Pagamenti',
      pay_a: 'Puoi pagare con carta di credito, PayPal e crediti prepagati (Buono Regalo).',
      fit_t: 'Misure',
      fit_a: 'Nella scheda di ogni capo trovi la tabella delle taglie e delle misure in cm (le T-shirt sono oversize, felpe e pantaloni regular fit).',
      back: 'Indietro',
      sizeLink: ' Apri la tabella taglie',
      another: 'Ho un\'altra domanda',
      enough: 'Mi basta, grazie',
      collection: 'Collezione',
      category: 'Categoria',
      which: 'Quale capo?',
      sizeOpt: 'Taglia (facoltativo)',
      height: 'Altezza (cm)',
      weight: 'Peso (kg)',
      eg178: 'es. 178',
      eg72: 'es. 72',
      order: 'Numero ordine',
      egOrder: 'es. #1006',
      cur: 'Taglia che hai ora',
      want: 'Taglia che vorresti',
      write: 'Scrivi qui il tuo messaggio',
      add: 'Vuoi aggiungere qualcosa? (facoltativo)',
      open: 'Apri WhatsApp',
      hint: 'Cliccando il pulsante si apre WhatsApp con le info inserite',
      m: { hi: 'Ciao Apocalisse Sold Out! 👋', req: 'Richiesta', item: 'Capo', coll: 'Collezione', cat: 'Categoria', order: 'Ordine', cur: 'Taglia attuale', want: 'Taglia desiderata', size: 'Taglia', hw: 'Altezza / peso', msg: 'Messaggio', page: 'Pagina', about: 'Domanda su: ' }
    },
    en: {
      hello: 'Hi! What do you need?',
      cats: ['T-SHIRT', 'HOODIES', 'PANTS'],
      topics: { info: 'Info about an item', size: 'Which size should I pick?', swap: 'Size exchange', refund: 'Return / withdrawal', other: 'Other' },
      quick: 'Quick answers',
      ship_t: 'Shipping',
      ship_a: 'We ship by courier: delivery takes 24/48 hours after your order is dispatched and you get an email with the tracking number. Shipping is free over €150.',
      pay_t: 'Payments',
      pay_a: 'You can pay by credit card, PayPal and prepaid credit (Gift Card).',
      fit_t: 'Measurements',
      fit_a: 'Every item\'s page has the size and measurement chart in cm (T-shirts are oversize, hoodies and pants are regular fit).',
      back: 'Back',
      sizeLink: ' Open the size chart',
      another: 'I have another question',
      enough: 'That\'s all, thanks',
      collection: 'Collection',
      category: 'Category',
      which: 'Which item?',
      sizeOpt: 'Size (optional)',
      height: 'Height (cm)',
      weight: 'Weight (kg)',
      eg178: 'e.g. 178',
      eg72: 'e.g. 72',
      order: 'Order number',
      egOrder: 'e.g. #1006',
      cur: 'Your current size',
      want: 'The size you want',
      write: 'Write your message here',
      add: 'Anything to add? (optional)',
      open: 'Open WhatsApp',
      hint: 'Clicking the button opens WhatsApp with the info you entered',
      m: { hi: 'Hi Apocalisse Sold Out! 👋', req: 'Request', item: 'Item', coll: 'Collection', cat: 'Category', order: 'Order', cur: 'Current size', want: 'Desired size', size: 'Size', hw: 'Height / weight', msg: 'Message', page: 'Page', about: 'Question about: ' }
    }
  };
  var LANG = (H.lang || 'it').slice(0, 2).toLowerCase();
  var T = DICT[LANG] || DICT.it;

  var cfg = {
    number: (root.getAttribute('data-number') || '').replace(/\D/g, ''),
    product: root.getAttribute('data-product') || '',
    productUrl: root.getAttribute('data-product-url') || '',
    collection: root.getAttribute('data-collection') || '',
    page: root.getAttribute('data-page') || '',
    sizeUrl: root.getAttribute('data-size-url') || '',
    hello: LANG === 'it' ? root.getAttribute('data-hello') || T.hello : T.hello,
    sizeType: (W.ASO_SZ && W.ASO_SZ.type) || '',
    delay: (parseInt(root.getAttribute('data-delay'), 10) || 12) * 1000
  };
  if (!cfg.number || !fab || !panel || !body) return;

  if (cfg.page === 'product' && !cfg.product) {
    var pt = D.querySelector('product-info .product__title, .product__title, h1');
    if (pt) cfg.product = pt.textContent.replace(/\s+/g, ' ').trim();
    cfg.productUrl = W.location.origin + W.location.pathname;
  }

  var desktop = W.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var COLLS = ['CUPIDO', 'PLUG', 'SPACE', 'BUTTERFLY', 'BASIC', 'LIMITED EDITION'];
  /* Cappelli e cover non ci sono: sono sempre esauriti */
  var CATS = T.cats;
  var CAT_TYPES = ['tshirt', 'hoodie', 'pants'];
  var SIZES = ['XS', 'S', 'M', 'L', 'XL'];
  var TOPIC_ICONS = { info: '👕', size: '📏', swap: '🔄', refund: '↩️', other: '💬' };
  var TOPICS = {};
  Object.keys(T.topics).forEach(function (k) {
    TOPICS[k] = { e: TOPIC_ICONS[k], t: T.topics[k] };
  });
  var QUICK = {
    ship: { t: T.ship_t, a: T.ship_a },
    pay: { t: T.pay_t, a: T.pay_a },
    fit: { t: T.fit_t, a: T.fit_a }
  };

  var ctx = {};

  /* piccoli ritocchi di stile: tasto indietro con freccia ben visibile, risposte veloci al centro, riga finale su una riga sola */
  var xs = D.createElement('style');
  xs.setAttribute('data-aso', 'wa-extra');
  xs.textContent =
    '.aso-wa__body .aso-wa__back{display:inline-flex;align-items:center;gap:.7rem;padding:.6rem 1.3rem .6rem .8rem;margin:0 0 .8rem;border:0;border-radius:99rem;background:rgba(138,31,192,.1);color:#8a1fc0;font:inherit;font-size:1.5rem;font-weight:600;line-height:1;cursor:pointer}' +
    '.aso-wa__body .aso-wa__back:hover,.aso-wa__body .aso-wa__back:focus-visible{background:rgba(138,31,192,.22)}' +
    '.aso-wa__body .aso-wa__arr{display:block;width:2.2rem;height:2.2rem;flex:none}' +
    '.aso-wa__body .aso-wa__quick{text-align:center}' +
    '.aso-wa__body .aso-wa__qrow{display:flex;flex-wrap:wrap;justify-content:center;gap:.8rem}' +
    '.aso-wa__body .aso-wa__hint{white-space:nowrap;text-align:center;font-size:1.05rem;letter-spacing:0;margin-left:0;margin-right:0}';
  D.head.appendChild(xs);

  function el(tag, cls, text) {
    var n = D.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function add(parent) {
    for (var i = 1; i < arguments.length; i++) if (arguments[i]) parent.appendChild(arguments[i]);
    return parent;
  }
  function btn(cls, text, fn) {
    var b = el('button', cls, text);
    b.type = 'button';
    if (fn) b.addEventListener('click', fn);
    return b;
  }
  /* tasto indietro: freccia a sinistra + parola */
  function backBtn(fn) {
    var b = el('button', 'aso-wa__back');
    b.type = 'button';
    b.setAttribute('aria-label', T.back);
    var s = D.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('class', 'aso-wa__arr');
    s.innerHTML = '<path d="M19 12H5M11 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>';
    b.appendChild(s);
    b.appendChild(el('span', null, T.back));
    b.addEventListener('click', fn);
    return b;
  }
  function icon(cls) {
    var s = D.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    s.innerHTML = ICON;
    if (cls) s.setAttribute('class', cls);
    return s;
  }
  function bubble(text, withLink) {
    var row = el('div', 'aso-wa__row');
    var av = el('span', 'aso-wa__av');
    av.appendChild(icon());
    var b = el('p', 'aso-wa__bubble', text);
    if (withLink && cfg.sizeUrl) {
      var a = el('a', null, T.sizeLink);
      a.href = cfg.sizeUrl;
      b.appendChild(D.createElement('br'));
      b.appendChild(a);
    }
    return add(row, av, b);
  }
  function clear() {
    body.textContent = '';
    body.scrollTop = 0;
  }

  /* tabella taglie giusta: quella del capo che si sta guardando, oppure della categoria scelta */
  function sizeBlock() {
    var ty = ctx.item ? cfg.sizeType : CAT_TYPES[CATS.indexOf(ctx.cat)];
    if (!ty || !W.asoSizeTable) return null;
    return W.asoSizeTable(ty, 'wa');
  }

  /* ---------- messaggio per WhatsApp (prima la categoria, poi la collezione) ---------- */
  function message() {
    var M = T.m;
    var L = [M.hi, M.req + ': ' + (TOPICS[ctx.topic] ? TOPICS[ctx.topic].t : TOPICS.other.t)];
    if (ctx.item) L.push(M.item + ': ' + ctx.item + (ctx.item === cfg.product && cfg.productUrl ? ' ' + cfg.productUrl : ''));
    if (ctx.cat) L.push(M.cat + ': ' + ctx.cat);
    if (ctx.coll) L.push(M.coll + ': ' + ctx.coll);
    if (ctx.order) L.push(M.order + ': ' + ctx.order);
    if (ctx.from) L.push(M.cur + ': ' + ctx.from);
    if (ctx.to) L.push(M.want + ': ' + ctx.to);
    if (ctx.size) L.push(M.size + ': ' + ctx.size);
    if (ctx.h || ctx.w) L.push(M.hw + ': ' + (ctx.h ? ctx.h + ' cm' : '-') + ' / ' + (ctx.w ? ctx.w + ' kg' : '-'));
    if (ctx.text) L.push(M.msg + ': ' + ctx.text);
    L.push(M.page + ': ' + W.location.origin + W.location.pathname);
    return L.join('\n');
  }
  function send() {
    var url = 'https://wa.me/' + cfg.number + '?text=' + encodeURIComponent(message());
    var w = null;
    try {
      w = W.open(url, '_blank', 'noopener');
    } catch (e) {}
    if (!w) W.location.href = url;
  }

  /* ---------- schermate ---------- */
  function home() {
    ctx = {};
    clear();
    add(body, bubble(cfg.hello));
    ['info', 'size', 'swap', 'refund', 'other'].forEach(function (k) {
      var b = el('button', 'aso-wa__opt');
      b.type = 'button';
      add(b, el('span', 'e', TOPICS[k].e), el('b', null, TOPICS[k].t));
      b.addEventListener('click', function () {
        ctx = { topic: k };
        if ((k === 'info' || k === 'size' || k === 'swap') && cfg.product) ctx.item = cfg.product;
        form();
      });
      body.appendChild(b);
    });
    var q = el('p', 'aso-wa__quick', T.quick);
    var qr = el('div', 'aso-wa__qrow');
    Object.keys(QUICK).forEach(function (k) {
      qr.appendChild(btn('aso-wa__chip', QUICK[k].t, function () {
        answer(k);
      }));
    });
    add(body, q, qr);
  }

  function answer(k) {
    clear();
    add(body, backBtn(home));
    add(body, bubble(QUICK[k].a, k === 'fit'));
    var go = btn('aso-wa__go', null, function () {
      ctx = { topic: 'other', text: T.m.about + QUICK[k].t };
      form();
    });
    add(go, icon(), el('span', null, T.another));
    add(body, go, btn('aso-wa__opt', T.enough, close));
  }

  function chips(label, list, key, onChange) {
    var wrap = el('div');
    add(wrap, el('span', 'aso-wa__label', label));
    var c = el('div', 'aso-wa__chips');
    list.forEach(function (v) {
      var b = btn('aso-wa__chip' + (ctx[key] === v ? ' is-on' : ''), v, function () {
        ctx[key] = ctx[key] === v ? '' : v;
        if (onChange) onChange();
        else form();
      });
      c.appendChild(b);
    });
    return add(wrap, c);
  }
  function field(label, key, tag, ph, type) {
    var wrap = el('div');
    add(wrap, el('span', 'aso-wa__label', label));
    var f = el(tag, tag === 'textarea' ? 'aso-wa__ta' : 'aso-wa__in');
    if (type) f.type = type;
    if (type === 'number') f.setAttribute('inputmode', 'numeric');
    if (ph) f.placeholder = ph;
    f.value = ctx[key] || '';
    f.addEventListener('input', function () {
      ctx[key] = f.value.trim();
    });
    return add(wrap, f);
  }
  function itemPicker() {
    var wrap = el('div');
    if (cfg.product) {
      var c = el('div', 'aso-wa__chips');
      add(wrap, el('span', 'aso-wa__label', T.which));
      var name = cfg.product.length > 30 ? cfg.product.slice(0, 29) + '…' : cfg.product;
      c.appendChild(btn('aso-wa__chip' + (ctx.item ? ' is-on' : ''), name, function () {
        ctx.item = ctx.item ? '' : cfg.product;
        form();
      }));
      add(wrap, c);
    }
    if (!ctx.item) {
      add(wrap, chips(T.category, CATS, 'cat'), chips(T.collection, COLLS, 'coll'));
    }
    return wrap;
  }

  function form() {
    var k = ctx.topic;
    clear();
    add(body, backBtn(home));
    add(body, bubble(TOPICS[k].e + ' ' + TOPICS[k].t));
    if (k === 'info' || k === 'size') add(body, itemPicker(), sizeBlock());
    if (k === 'info') add(body, chips(T.sizeOpt, SIZES, 'size'));
    if (k === 'size') {
      var two = el('div', 'aso-wa__two');
      add(two, field(T.height, 'h', 'input', T.eg178, 'number'), field(T.weight, 'w', 'input', T.eg72, 'number'));
      add(body, two);
    }
    if (k === 'swap') {
      add(body, field(T.order, 'order', 'input', T.egOrder, 'text'));
      add(body, chips(T.cur, SIZES, 'from'), chips(T.want, SIZES, 'to'), sizeBlock());
    }
    if (k === 'refund') add(body, field(T.order, 'order', 'input', T.egOrder, 'text'));
    var lab = k === 'other' ? T.write : T.add;
    add(body, field(lab, 'text', 'textarea', ''));
    var go = btn('aso-wa__go', null, send);
    add(go, icon(), el('span', null, T.open));
    add(body, go, el('p', 'aso-wa__hint', T.hint));
  }

  /* ---------- apri / chiudi ---------- */
  function open() {
    if (!root.classList.contains('is-open')) home();
    root.classList.add('is-open');
    H.classList.add('aso-wa-open');
    fab.setAttribute('aria-expanded', 'true');
    evaluate();
    W.setTimeout(function () {
      var f = body.querySelector('button');
      if (f && root.classList.contains('is-open')) f.focus({ preventScroll: true });
    }, 60);
  }
  function close() {
    root.classList.remove('is-open');
    H.classList.remove('aso-wa-open');
    fab.setAttribute('aria-expanded', 'false');
    evaluate();
  }
  fab.addEventListener('click', function () {
    if (root.classList.contains('is-open')) close();
    else open();
  });
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (scrim) scrim.addEventListener('click', close);
  D.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) {
      close();
      fab.focus({ preventScroll: true });
    }
  });
  /* Clic fuori dal pannello (solo computer) lo chiude.
     Il controllo si fa PRIMA che la chat ridisegni le schermate (fase di cattura): quando si preme una voce il pulsante
     viene tolto dalla pagina e, controllato dopo, sembrava un clic "fuori": per questo su computer il pannello si chiudeva da solo. */
  D.addEventListener(
    'click',
    function (e) {
      if (!desktop || !root.classList.contains('is-open')) return;
      var path = e.composedPath ? e.composedPath() : [];
      if (path.indexOf(root) > -1 || root.contains(e.target)) return;
      close();
    },
    true
  );

  /* ---------- quando il pulsante si vede ---------- */
  var CTA = '.product-form__submit,button[name="add"],button[name="checkout"],#checkout,.cart__checkout-button,.shopify-payment-button,.quick-add__submit';
  var OVERLAY = 'header-drawer details[open],details-modal details[open],quick-add-modal[open],cart-notification.active,cart-drawer.active';
  var armed = desktop, scrolling = false, kbd = false, lastY = W.pageYOffset || 0, st = 0, ticking = false;

  function collides() {
    var f = fab.getBoundingClientRect();
    var els = D.querySelectorAll(CTA);
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.width === 0 || r.height === 0) continue;
      if (r.bottom > f.top - 12 && r.top < f.bottom + 12 && r.right > f.left - 12 && r.left < f.right + 12) return true;
    }
    return false;
  }

  /* la barra fissa "Aggiungi al carrello" si legge solo quando c'e davvero (prima si leggeva a ogni aggiornamento) */
  function lift() {
    var bar = H.classList.contains('aso-satc-on');
    var theirs = fab.style.getPropertyValue('translate');
    var h = bar ? parseFloat(W.getComputedStyle(H).getPropertyValue('--aso-satc-h')) || 0 : 0;
    root.style.setProperty('--aso-wa-lift', (bar && !theirs ? h + 10 : 0) + 'px');
    root.style.setProperty('--aso-wa-plift', (bar ? h + 10 : 0) + 'px');
  }

  function evaluate() {
    ticking = false;
    lift();
    var show;
    if (root.classList.contains('is-open')) {
      show = true;
    } else if (desktop) {
      show = armed;
    } else {
      show = armed && !scrolling && !kbd && !D.body.classList.contains('overflow-hidden') && !D.querySelector(OVERLAY) && !collides();
    }
    root.classList.toggle('is-shown', !!show);
  }
  function queue() {
    if (ticking) return;
    ticking = true;
    W.requestAnimationFrame(evaluate);
  }

  function onScroll() {
    var y = W.pageYOffset || 0;
    if (!armed && y > 320) armed = true;
    if (!desktop && Math.abs(y - lastY) > 4) {
      scrolling = true;
      W.clearTimeout(st);
      st = W.setTimeout(function () {
        scrolling = false;
        queue();
      }, 700);
    }
    lastY = y;
    queue();
  }

  W.addEventListener('scroll', onScroll, { passive: true });
  W.addEventListener('resize', queue);
  D.addEventListener('toggle', function () { W.setTimeout(queue, 30); }, true);
  D.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName) && !root.contains(t)) {
      kbd = true;
      queue();
    }
  });
  D.addEventListener('focusout', function () {
    W.setTimeout(function () {
      var a = D.activeElement;
      kbd = !!(a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !root.contains(a));
      queue();
    }, 120);
  });
  /* al posto del controllo periodico: si ricontrolla quando cambiano le classi della pagina e del corpo
     (menu, carrello laterale, finestre aperte bloccano lo scorrimento con overflow-hidden), del pulsante,
     e quando si apre o chiude una finestra (carrello laterale, aggiunta rapida) */
  if (W.MutationObserver) {
    new MutationObserver(queue).observe(H, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(queue).observe(D.body, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(queue).observe(fab, { attributes: true, attributeFilter: ['style'] });
    D.querySelectorAll('cart-drawer, cart-notification, quick-add-modal').forEach(function (n) {
      new MutationObserver(queue).observe(n, { attributes: true, attributeFilter: ['class', 'open'] });
    });
  }

  W.setTimeout(function () {
    armed = true;
    queue();
  }, desktop ? 700 : cfg.delay);
  if ((W.pageYOffset || 0) > 320) armed = true;
  queue();
})();
